<div class="container py-4">
  <section class="mb-4 d-flex align-items-start justify-content-between">
    <div>
      <div class="feedback-participant-name h4 font-weight-bold mb-0">{{ view.participantName }}</div>
      <a class="text-muted d-block mt-2" [href]="eventUrl" target="_blank" rel="noopener">{{ view.eventName }}</a>
      <div class="d-flex flex-wrap align-items-baseline">
        <a class="text-muted" [href]="resultsUrl" target="_blank" rel="noopener">{{ view.categoryName }}</a>
      </div>
    </div>
    @if (totalPrograms > 1) {
      <button type="button" class="btn btn-outline-primary" (click)="toggleAll()">
        {{ (anyExpanded() ? 'viewFeedback.collapseAll' : 'viewFeedback.expandAll') | translate }}
      </button>
    }
  </section>

  @if (rounds.length === 0) {
    <div class="text-center py-5">
      <h2 class="section-heading">{{ 'viewFeedback.empty.title' | translate }}</h2>
    </div>
  }

  @if (resultCategory !== null) {
    <div>
      <span class="tanvo-result-category font-weight-bold">
        {{ 'viewFeedback.tanvo.resultCategory' | translate: { category: resultCategory } }}
      </span>
    </div>
  }

  @for (round of rounds; track $index) {
    <div class="mb-4">
      @for (program of round.programs; track $index) {
        <div class="feedback-program sh-block overflow-hidden mb-3">
          @if (totalPrograms > 1) {
            <button
              type="button"
              class="feedback-program__header d-flex align-items-center justify-content-between w-100 bg-primary border-0 text-left text-white"
              (click)="toggleProgram(program)"
            >
              <span class="d-flex align-items-center">
                <span class="feedback-chevron text-white mr-2" [class.feedback-chevron--open]="!program.collapsed"
                  >&rsaquo;</span
                >
                <span class="font-weight-bold">{{ round.roundName }}</span>
              </span>
            </button>
          }

          @if (!program.collapsed) {
            <div class="feedback-program__body bg-white">
              @for (judge of program.judges; track judge.judgeCode) {
                <div class="feedback-section">
                  <button
                    type="button"
                    class="feedback-section__title d-flex align-items-center justify-content-between w-100 bg-info border-0 text-white"
                    (click)="toggleJudge(judge)"
                  >
                    <span class="font-weight-bold">{{ judge.judgeCode }}</span>
                    <span class="d-flex align-items-center">
                      @if (judge.criteria.length) {
                        <span class="font-weight-bold mr-3">{{ judge.total | number: '1.1-1' }}</span>
                      }
                      <span
                        class="feedback-section__chevron d-inline-block"
                        [class.feedback-section__chevron--collapsed]="judge.collapsed"
                        >&rsaquo;</span
                      >
                    </span>
                  </button>

                  @if (!judge.collapsed) {
                    <div class="d-flex flex-column flex-md-row bg-white">
                      @if (judge.criteria.length) {
                        <table class="kn-table kn-table__w100 tanvo-criteria tanvo-col">
                          <tbody>
                            @for (criterion of judge.criteria; track $index) {
                              <tr class="tanvo-criterion">
                                <td class="tanvo-criterion__num text-primary font-weight-bold">{{ $index + 1 }}</td>
                                <td class="tanvo-criterion__label w-100">{{ criterion.label }}</td>
                                <td class="tanvo-criterion__score text-primary font-weight-bold text-right text-nowrap">
                                  {{ criterion.value | number: '1.1-1' }}
                                </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      }

                      <div class="tanvo-feedback tanvo-col p-3">
                        @if (judge.texts.length) {
                          @for (text of judge.texts; track $index) {
                            <div class="tanvo-feedback__field">
                              <div class="tanvo-feedback__title font-weight-bold mb-2">
                                {{ text.labelKey | translate }}
                              </div>
                              @if (text.text) {
                                <span class="tanvo-feedback__text">{{ text.text }}</span>
                              } @else {
                                <span class="text-muted font-italic">{{ text.textKey | translate }}</span>
                              }
                            </div>
                          }
                        } @else {
                          <div class="tanvo-feedback__title font-weight-bold mb-2">
                            {{ 'viewFeedback.judgeFeedback' | translate }}
                          </div>
                          <span class="text-muted font-italic">{{ 'viewFeedback.awaitingFeedback' | translate }}</span>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
